<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 12V16H8L16 8L12 4L4 12Z" />
  <path
    d="M17 7L13 3L15.2929 0.707107C15.6834 0.316582 16.3166 0.316582 16.7071 0.707106L19.2929 3.29289C19.6834 3.68342 19.6834 4.31658 19.2929 4.70711L17 7Z"
  />
  <path
    d="M19 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20Z"
  />
</svg>
